import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { InjectionToken, Directive, EventEmitter, Component, ChangeDetectionStrategy, Input, Output, HostListener, ViewChild, Injectable, Inject, NgModule } from '@angular/core';
import * as i1$2 from '@ngrx/store';
import { compose, combineReducers, StoreModule } from '@ngrx/store';
import * as i3 from '@play/common';
import { CommonsErrorModule, CommonsComponentModule, CommonsLoadingModule, SvgIconsModule } from '@play/common';
import * as i5 from '@play/translate';
import { TranslationModule } from '@play/translate';
import * as i1$1 from '@angular/common/http';
import { HttpParams, HttpHeaders, HttpClientModule } from '@angular/common/http';
import * as i2 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i1$3 from '@ngrx/effects';
import { ofType, Effect, EffectsModule } from '@ngrx/effects';
import { type, spammyActionType, createLoadSelector, LoadMatchOnceAction, getMatch, exists, entryAvailable, LoadLeagueOnceAction, getLeague, LoadRosterOnceAction, getRostersForTeams, LoadMatchAction, createErrorObject, StateModule, createMultipleLoadReducer } from '@play/state';
import * as csvjson from 'csvjson';
import { throwError, BehaviorSubject, combineLatest, of, Observable } from 'rxjs';
import { map, catchError, first, filter, tap, switchMap, shareReplay, combineLatest as combineLatest$1, startWith, mergeMap, skip, takeUntil } from 'rxjs/operators';
import { Map } from 'immutable';
import { isTeam, hasIntegration } from '@play/utility/league';
import { __decorate, __metadata } from 'tslib';

const FFA_RESULT_CONFIG = new InjectionToken("ffa-result.config");
const FFAResultProdConfig = {
    baseUrl: "/",
};

class FocusOnInitDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    ngAfterViewInit() {
        this.elementRef.nativeElement.focus();
    }
}
FocusOnInitDirective.ɵfac = function FocusOnInitDirective_Factory(t) { return new (t || FocusOnInitDirective)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
FocusOnInitDirective.ɵdir = i0.ɵɵdefineDirective({ type: FocusOnInitDirective, selectors: [["", "focusOnInit", ""]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FocusOnInitDirective, [{
        type: Directive,
        args: [{
                selector: "[focusOnInit]",
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, null); })();

function FilterDropdownComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "span", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "svg-icon", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.item.label, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("width", 24, "px")("height", 24, "px");
    i0.ɵɵproperty("icon", "chevron-right");
} }
function FilterDropdownComponent_input_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 9, 10);
    i0.ɵɵlistener("keyup", function FilterDropdownComponent_input_3_Template_input_keyup_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.handleFilterChange($event); })("click", function FilterDropdownComponent_input_3_Template_input_click_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.handleInputClick($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r1.filter);
} }
function FilterDropdownComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵlistener("click", function FilterDropdownComponent_div_4_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.reset($event); });
    i0.ɵɵtext(1, " x ");
    i0.ɵɵelementEnd();
} }
function FilterDropdownComponent_div_5_li_3_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 16);
    i0.ɵɵlistener("click", function FilterDropdownComponent_div_5_li_3_Template_li_click_0_listener() { i0.ɵɵrestoreView(_r14); const item_r12 = ctx.$implicit; const ctx_r13 = i0.ɵɵnextContext(2); return ctx_r13.handleSelectItem(item_r12.id); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r12 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r12.label, " ");
} }
function FilterDropdownComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12, 13);
    i0.ɵɵlistener("click", function FilterDropdownComponent_div_5_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.handleDropdownClick($event); });
    i0.ɵɵelementStart(2, "ul", 14);
    i0.ɵɵtemplate(3, FilterDropdownComponent_div_5_li_3_Template, 2, 1, "li", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r3.filteredItems);
} }
class FilterDropdownComponent {
    constructor() {
        this.selectedItem = undefined;
        this.newItem = new EventEmitter();
        this.dropdownShown = false;
        this.filter = "";
    }
    ngOnChanges() {
        this.applyFilter(this.filter);
    }
    clickout() {
        this.dropdownShown = false;
    }
    get item() {
        return (this.selectedItem || {
            id: 0,
            label: "Pick a contestant",
            tags: [],
        });
    }
    showDropdown(event) {
        event.stopPropagation();
        this.dropdownShown = true;
    }
    hideDropdown(event) {
        this.dropdownShown = false;
    }
    reset(event) {
        event.stopPropagation();
        this.selectedItem = undefined;
        this.dropdownShown = false;
        this.newItem.emit(undefined);
    }
    handleDropdownClick(event) {
        event.stopPropagation();
    }
    handleInputClick(event) {
        event.stopPropagation();
    }
    handleFilterChange(event) {
        this.filter = event.target.value;
        this.applyFilter(this.filter);
        if (event.which === 13 && this.filteredItems) {
            this.handleSelectItem(this.filteredItems[0].id);
        }
    }
    applyFilter(filter) {
        if (!filter) {
            // If no filter is applied, just return all items as they are.
            this.filteredItems = this.items.map(i => ({
                id: i.id,
                label: i.label,
            }));
            return;
        }
        const result = [];
        const filterString = this.filter ? this.filter.toLocaleLowerCase() : this.filter;
        this.items.forEach(item => {
            const labelString = item.label ? item.label.toLocaleLowerCase() : item.label;
            if (labelString.indexOf(filterString) !== -1) {
                result.push({ id: item.id, label: `${item.label}` });
                return;
            }
            item.tags.some(tag => {
                const tagString = tag ? tag.toLocaleLowerCase() : tag;
                if (tag && tagString.indexOf(filterString) !== -1) {
                    result.push({
                        id: item.id,
                        label: `(${tag}) ${item.label}`,
                    });
                    return true;
                }
            });
        });
        this.filteredItems = result;
    }
    handleSelectItem(id) {
        this.newItem.emit(id);
        this.dropdownShown = false;
    }
}
FilterDropdownComponent.ɵfac = function FilterDropdownComponent_Factory(t) { return new (t || FilterDropdownComponent)(); };
FilterDropdownComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FilterDropdownComponent, selectors: [["filter-dropdown"]], hostBindings: function FilterDropdownComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function FilterDropdownComponent_click_HostBindingHandler() { return ctx.clickout(); }, false, i0.ɵɵresolveDocument);
    } }, inputs: { items: "items", selectedItem: "selectedItem" }, outputs: { newItem: "newItem" }, features: [i0.ɵɵNgOnChangesFeature], decls: 6, vars: 4, consts: [[1, "c-filter-dropdown"], [1, "c-filter-dropdown__item", 3, "click"], ["class", "c-filter-dropdown__select", 4, "ngIf"], ["type", "text", "focusOnInit", "", "class", "c-filter-dropdown__search", 3, "value", "keyup", "click", 4, "ngIf"], ["class", "c-filter-dropdown__reset", 3, "click", 4, "ngIf"], ["class", "c-filter-dropdown__dropdown", 3, "click", 4, "ngIf"], [1, "c-filter-dropdown__select"], [1, "c-filter-dropdown__label"], [1, "c-filter-dropdown__chevron", 3, "icon"], ["type", "text", "focusOnInit", "", 1, "c-filter-dropdown__search", 3, "value", "keyup", "click"], ["input", ""], [1, "c-filter-dropdown__reset", 3, "click"], [1, "c-filter-dropdown__dropdown", 3, "click"], ["dropdown", ""], [1, "c-filter-dropdown__item-list"], ["class", "c-filter-dropdown__item-list__item", 3, "click", 4, "ngFor", "ngForOf"], [1, "c-filter-dropdown__item-list__item", 3, "click"]], template: function FilterDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵlistener("click", function FilterDropdownComponent_Template_div_click_1_listener($event) { return ctx.showDropdown($event); });
        i0.ɵɵtemplate(2, FilterDropdownComponent_div_2_Template, 4, 6, "div", 2);
        i0.ɵɵtemplate(3, FilterDropdownComponent_input_3_Template, 2, 1, "input", 3);
        i0.ɵɵtemplate(4, FilterDropdownComponent_div_4_Template, 2, 0, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, FilterDropdownComponent_div_5_Template, 4, 1, "div", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.dropdownShown);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dropdownShown);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dropdownShown);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dropdownShown);
    } }, directives: [i1.NgIf, i3.SvgIconComponent, FocusOnInitDirective, i1.NgForOf], styles: ["[_nghost-%COMP%] {\n                display: block;\n                width: 100%;\n            }"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterDropdownComponent, [{
        type: Component,
        args: [{
                selector: "filter-dropdown",
                templateUrl: "./filter-dropdown.component.html",
                styles: [
                    `
            :host {
                display: block;
                width: 100%;
            }
        `,
                ],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { items: [{
            type: Input
        }], selectedItem: [{
            type: Input
        }], newItem: [{
            type: Output
        }], clickout: [{
            type: HostListener,
            args: ["document:click"]
        }] }); })();

function FFAResultPlayerComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" Gameaccount: ", ctx_r0.gameaccount, " ");
} }
function FFAResultPlayerComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1, " no gameaccount ");
    i0.ɵɵelementEnd();
} }
class FFAResultPlayerComponent {
    constructor() {
        this.kills = 0;
        this.newKills = new EventEmitter();
    }
    handleNewKills(kills) {
        this.newKills.emit(+kills);
    }
}
FFAResultPlayerComponent.ɵfac = function FFAResultPlayerComponent_Factory(t) { return new (t || FFAResultPlayerComponent)(); };
FFAResultPlayerComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FFAResultPlayerComponent, selectors: [["ffa-result-player"]], inputs: { gameaccount: "gameaccount", kills: "kills" }, outputs: { newKills: "newKills" }, decls: 7, vars: 3, consts: [[1, "c-ffa-result-player"], ["class", "c-ffa-result-player__gameaccount", 4, "ngIf"], [1, "c-ffa-result-player__inputs"], ["type", "number", "placeholder", "kills", 1, "c-ffa-result-player__kills", 3, "value", "change"], [1, "c-ffa-result-player__kills-label"], [1, "c-ffa-result-player__gameaccount"]], template: function FFAResultPlayerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, FFAResultPlayerComponent_div_1_Template, 2, 1, "div", 1);
        i0.ɵɵtemplate(2, FFAResultPlayerComponent_div_2_Template, 2, 0, "div", 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "input", 3);
        i0.ɵɵlistener("change", function FFAResultPlayerComponent_Template_input_change_4_listener($event) { return ctx.handleNewKills($event.target.value); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "label", 4);
        i0.ɵɵtext(6, " kills ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.gameaccount !== undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.gameaccount === undefined);
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("value", ctx.kills);
    } }, directives: [i1.NgIf], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FFAResultPlayerComponent, [{
        type: Component,
        args: [{
                selector: "ffa-result-player",
                templateUrl: "./ffa-result-player.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { gameaccount: [{
            type: Input
        }], kills: [{
            type: Input
        }], newKills: [{
            type: Output
        }] }); })();

function FFAResultMembersComponent_div_1_option_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const member_r4 = ctx.$implicit;
    const i_r2 = i0.ɵɵnextContext().index;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", member_r4.id)("selected", ctx_r3.players[i_r2] && ctx_r3.players[i_r2].id === member_r4.id);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", member_r4.gameaccount, " ");
} }
function FFAResultMembersComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "select", 3);
    i0.ɵɵlistener("change", function FFAResultMembersComponent_div_1_Template_select_change_1_listener($event) { i0.ɵɵrestoreView(_r7); const i_r2 = ctx.index; const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.handleSelectPlayer(i_r2, $event.target.value); });
    i0.ɵɵtemplate(2, FFAResultMembersComponent_div_1_option_2_Template, 2, 3, "option", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 5);
    i0.ɵɵelementStart(4, "input", 6);
    i0.ɵɵlistener("change", function FFAResultMembersComponent_div_1_Template_input_change_4_listener($event) { i0.ɵɵrestoreView(_r7); const i_r2 = ctx.index; const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.handleNewKills(i_r2, $event.target.value); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "label", 7);
    i0.ɵɵtext(6, " kills ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const player_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.playerOptions)("ngForTrackBy", ctx_r0.playerTrackBy);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", player_r1.kills);
} }
class FFAResultMembersComponent {
    constructor() {
        this.newPlayers = new EventEmitter();
        this.newKills = new EventEmitter();
        this.playerOptions = [];
    }
    ngOnChanges(changes) {
        const unknownDummies = this.buildInitialMembers(this.teamSize);
        const playerOptions = [...this.members];
        unknownDummies.forEach(dummy => {
            const hasOption = Boolean(playerOptions.find(option => option.id === dummy.id));
            if (!hasOption) {
                playerOptions.push(dummy);
            }
        });
        this.playerOptions = playerOptions;
    }
    handleSelectPlayer(slot, id) {
        const newPlayer = this.playerOptions.find(member => member.id === +id);
        const newPlayers = [...this.players];
        newPlayers[slot] = Object.assign(Object.assign({}, newPlayer), { kills: 0 });
        this.newPlayers.emit(newPlayers);
    }
    handleNewKills(slot, kills) {
        this.newKills.emit({ slot: slot, kills: +kills });
    }
    buildInitialMembers(amount) {
        const players = [];
        for (let i = 1; i <= amount; i++) {
            players.push(this.buildInitialMember(i));
        }
        return players;
    }
    buildInitialMember(numero) {
        return { id: -numero, gameaccount: `Unknown${numero}` };
    }
    playerTrackBy(index, player) {
        return player.id;
    }
}
FFAResultMembersComponent.ɵfac = function FFAResultMembersComponent_Factory(t) { return new (t || FFAResultMembersComponent)(); };
FFAResultMembersComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FFAResultMembersComponent, selectors: [["ffa-result-members"]], inputs: { players: "players", members: "members", teamSize: "teamSize" }, outputs: { newPlayers: "newPlayers", newKills: "newKills" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 1, consts: [[1, "c-ffa-members"], ["class", "c-ffa-members__player", 4, "ngFor", "ngForOf"], [1, "c-ffa-members__player"], [1, "c-ffa-members__player__select", 3, "change"], [3, "value", "selected", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "c-ffa-members__kills-container"], ["type", "number", "placeholder", "kills", 1, "c-ffa-members__kills", 3, "value", "change"], [1, "c-ffa-members__kills-label"], [3, "value", "selected"]], template: function FFAResultMembersComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, FFAResultMembersComponent_div_1_Template, 7, 3, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.players);
    } }, directives: [i1.NgForOf, i2.NgSelectOption, i2.ɵangular_packages_forms_forms_z], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FFAResultMembersComponent, [{
        type: Component,
        args: [{
                selector: "ffa-result-members",
                templateUrl: "./ffa-result-members.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { players: [{
            type: Input
        }], members: [{
            type: Input
        }], teamSize: [{
            type: Input
        }], newPlayers: [{
            type: Output
        }], newKills: [{
            type: Output
        }] }); })();

const _c0 = ["input"];
const _c1 = ["dropdown"];
function FFAResultRankComponent_ffa_result_members_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ffa-result-members", 6);
    i0.ɵɵlistener("newPlayers", function FFAResultRankComponent_ffa_result_members_5_Template_ffa_result_members_newPlayers_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.handleNewPlayers($event); })("newKills", function FFAResultRankComponent_ffa_result_members_5_Template_ffa_result_members_newKills_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.handleNewKills($event.slot, $event.kills); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("players", ctx_r0.ffaContestant.players)("members", ctx_r0.ffaContestant.members)("teamSize", ctx_r0.teamSize);
} }
function FFAResultRankComponent_ffa_result_player_6_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ffa-result-player", 7);
    i0.ɵɵlistener("newKills", function FFAResultRankComponent_ffa_result_player_6_Template_ffa_result_player_newKills_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.handleNewPlayerKills($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("kills", ctx_r1.firstPlayer == null ? null : ctx_r1.firstPlayer.kills)("gameaccount", ctx_r1.firstPlayer == null ? null : ctx_r1.firstPlayer.gameaccount);
} }
class FFAResultRankComponent {
    constructor() {
        this.newContestant = new EventEmitter();
        this.contestantFilter = "";
    }
    ngOnChanges(changes) {
        this.selectedItem =
            this.ffaContestant.id === 0
                ? undefined
                : {
                    id: this.ffaContestant.id,
                    label: this.ffaContestant.name,
                    tags: this.ffaContestant.members.map(member => member.gameaccount),
                };
        this.availableItems = this.availableTeams.map(team => ({
            id: team.id,
            label: team.name,
            tags: [...team.members.map(member => member.gameaccount)],
        }));
        this.firstPlayer = this.ffaContestant ? this.ffaContestant.players[0] : null;
    }
    selectTeam(team, players) {
        const selectedTeam = this.availableTeams.find(item => item.id === team.id);
        const newContestant = Object.assign(Object.assign({}, this.ffaContestant), { id: team.id, name: team.name, players: players, members: selectedTeam ? selectedTeam.members : [] });
        this.newContestant.emit(newContestant);
    }
    handleSelectTeam(team) {
        const players = team.id ? this.buildInitialPlayers(this.teamSize, team.members) : [];
        this.selectTeam(team, players);
    }
    buildInitialMembers(amount) {
        const players = [];
        for (let i = 1; i <= amount; i++) {
            players.push(this.buildInitialMember(i));
        }
        return players;
    }
    buildInitialMember(numero) {
        return { id: -numero, gameaccount: `Unknown${numero}` };
    }
    handleNewPlayers(players) {
        this.newContestant.emit(Object.assign(Object.assign({}, this.ffaContestant), { players: players }));
    }
    handleNewKills(slot, kills) {
        const newPlayers = [...this.ffaContestant.players];
        newPlayers[slot] = Object.assign(Object.assign({}, newPlayers[slot]), { kills: +kills });
        const newContestant = Object.assign(Object.assign({}, this.ffaContestant), { players: newPlayers });
        this.newContestant.emit(newContestant);
    }
    handleNewPlayerKills(kills) {
        const contestant = Object.assign(Object.assign({}, this.ffaContestant), { players: this.ffaContestant.players.map(player => {
                return Object.assign(Object.assign({}, player), { kills: +kills });
            }) });
        this.newContestant.emit(contestant);
    }
    buildInitialPlayers(amount, members) {
        const players = members.length <= amount ? [...members] : [];
        // Fill up players with "Unknown" placeholders
        for (let i = players.length + 1; i <= amount; i++) {
            players.push(this.buildInitialMember(i));
        }
        return players.map(player => {
            return Object.assign(Object.assign({}, player), { kills: 0 });
        });
    }
    handleNewContestant(id) {
        if (id === undefined) {
            this.handleSelectTeam({ id: undefined });
            return;
        }
        const team = this.availableTeams.find(t => t.id === id);
        this.handleSelectTeam(team);
    }
}
FFAResultRankComponent.ɵfac = function FFAResultRankComponent_Factory(t) { return new (t || FFAResultRankComponent)(); };
FFAResultRankComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FFAResultRankComponent, selectors: [["ffa-result-rank"]], viewQuery: function FFAResultRankComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
        i0.ɵɵviewQuery(_c1, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
    } }, inputs: { availableTeams: "availableTeams", ffaContestant: "ffaContestant", teamSize: "teamSize", isTeam: "isTeam" }, outputs: { newContestant: "newContestant" }, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 5, consts: [[1, "ffa-rank"], [1, "ffa-rank__rank"], [1, "ffa-rank__contestant-container"], [3, "items", "selectedItem", "newItem"], [3, "players", "members", "teamSize", "newPlayers", "newKills", 4, "ngIf"], [3, "kills", "gameaccount", "newKills", 4, "ngIf"], [3, "players", "members", "teamSize", "newPlayers", "newKills"], [3, "kills", "gameaccount", "newKills"]], template: function FFAResultRankComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "filter-dropdown", 3);
        i0.ɵɵlistener("newItem", function FFAResultRankComponent_Template_filter_dropdown_newItem_4_listener($event) { return ctx.handleNewContestant($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, FFAResultRankComponent_ffa_result_members_5_Template, 1, 3, "ffa-result-members", 4);
        i0.ɵɵtemplate(6, FFAResultRankComponent_ffa_result_player_6_Template, 1, 2, "ffa-result-player", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" #", ctx.ffaContestant.rank, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("items", ctx.availableItems)("selectedItem", ctx.selectedItem);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isTeam);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.ffaContestant.id !== undefined && !ctx.isTeam && ctx.ffaContestant.players.length);
    } }, directives: [FilterDropdownComponent, i1.NgIf, FFAResultMembersComponent, FFAResultPlayerComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FFAResultRankComponent, [{
        type: Component,
        args: [{
                selector: "ffa-result-rank",
                templateUrl: "./ffa-result-rank.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { availableTeams: [{
            type: Input
        }], ffaContestant: [{
            type: Input
        }], teamSize: [{
            type: Input
        }], isTeam: [{
            type: Input
        }], newContestant: [{
            type: Output
        }], input: [{
            type: ViewChild,
            args: ["input"]
        }], dropdown: [{
            type: ViewChild,
            args: ["dropdown"]
        }] }); })();

class FFAErrorResponse {
    constructor(response) {
        try {
            this.status = response.status;
            /**
             * While on localhost we get a JSON string for 404s, and on drupal we get an already parsed array.
             * No idea why this happens.
             * For now we check if we have array or not and react accordingly.
             */
            const errors = response.error instanceof Array ? response.error : JSON.parse(response.error);
            this.errors = errors.map(error => error.message);
        }
        catch ($e) {
            this.status = 500;
            this.errors = ["Unknown Error"];
        }
    }
    getStatus() {
        return this.status;
    }
    getErrors() {
        return this.errors;
    }
}
function handleFFAError(error, catched) {
    console.error(error);
    return throwError(new FFAErrorResponse(error));
}
class FFAResultService {
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this.resultUrl = "interface/feature/index.php";
    }
    get(matchId) {
        const params = new HttpParams()
            .set("matchId", `${matchId}`)
            .set("f", "adminFfaManager")
            .set("a", "getResult")
            .set("nurlp", this.getNurlp());
        return this.http
            .get(`${this.config.baseUrl}${this.resultUrl}`, {
            params: params,
            headers: this.getHeaders(),
        })
            .pipe(map((result) => result.contestants), catchError(handleFFAError));
    }
    saveAndClose(matchId, result) {
        return this.submit(matchId, result, true);
    }
    save(matchId, result) {
        return this.submit(matchId, result, false);
    }
    submit(matchId, result, commit) {
        const apiResult = result.filter(contestant => contestant.id !== undefined);
        let params = new HttpParams()
            .set("matchId", `${matchId}`)
            .set("data", JSON.stringify(apiResult))
            .set("f", "adminFfaManager")
            .set("a", "saveResult")
            .set("nurlp", this.getNurlp());
        if (commit) {
            params = params.set("commit", "true");
        }
        return this.http
            .post(this.config.baseUrl + this.resultUrl, params, {
            withCredentials: true,
            headers: this.getHeaders(),
        })
            .pipe(catchError(handleFFAError));
    }
    getHeaders() {
        return new HttpHeaders().set("X-Requested-With", "XMLHttpRequest");
    }
    getNurlp() {
        const prefix = Drupal.settings.legacy_content.prefix;
        const path = window.location.pathname.replace("/", ""); // replace the first "/" as the prefix as a "/" at the end
        return "/" + prefix + path;
    }
}
FFAResultService.ɵfac = function FFAResultService_Factory(t) { return new (t || FFAResultService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(FFA_RESULT_CONFIG)); };
FFAResultService.ɵprov = i0.ɵɵdefineInjectable({ token: FFAResultService, factory: FFAResultService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FFAResultService, [{
        type: Injectable,
        args: [{
                providedIn: "root",
            }]
    }], function () { return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [FFA_RESULT_CONFIG]
            }] }]; }, null); })();

class GiResultService extends FFAResultService {
    featureName() {
        return "gameIntegration" + this.integration.charAt(0).toUpperCase() + this.integration.substr(1);
    }
    get(matchId) {
        const params = new HttpParams()
            .set("matchId", `${matchId}`)
            .set("f", this.featureName())
            .set("a", "getResult")
            .set("nurlp", this.getNurlp());
        return this.http
            .get(this.config.baseUrl + this.resultUrl, {
            params: params,
            headers: this.getHeaders(),
        })
            .pipe(map((result) => result.contestants), catchError(handleFFAError));
    }
    saveAndClose(matchId, result) {
        return this.submit(matchId, result, true);
    }
    save(matchId, result) {
        return this.submit(matchId, result, false);
    }
    saveCsv(matchId, csv) {
        const params = new HttpParams()
            .set("matchId", `${matchId}`)
            .set("data", JSON.stringify(csv))
            .set("f", this.featureName())
            .set("a", "saveLobbyResult")
            .set("nurlp", this.getNurlp());
        return this.http
            .post(this.config.baseUrl + this.resultUrl, params, {
            withCredentials: true,
            headers: this.getHeaders(),
        })
            .pipe(catchError(handleFFAError));
    }
    saveByLobbyId(matchId, lobbyId, hostNickName) {
        const params = new HttpParams()
            .set("matchId", `${matchId}`)
            .set("lobbyId", lobbyId)
            .set("hostNickName", hostNickName)
            .set("f", this.featureName())
            .set("a", "saveByLobbyId")
            .set("nurlp", this.getNurlp());
        return this.http
            .post(`${this.config.baseUrl}${this.resultUrl}`, params, {
            withCredentials: true,
            headers: this.getHeaders(),
        })
            .pipe(catchError(handleFFAError));
    }
    submit(matchId, result, commit) {
        const apiResult = result.filter(contestant => contestant.id !== undefined);
        let params = new HttpParams()
            .set("matchId", `${matchId}`)
            .set("data", JSON.stringify(apiResult))
            .set("f", this.featureName())
            .set("a", "saveResult")
            .set("nurlp", this.getNurlp());
        if (commit) {
            params = params.set("commit", "true");
        }
        return this.http
            .post(this.config.baseUrl + this.resultUrl, params, {
            withCredentials: true,
            headers: this.getHeaders(),
        })
            .pipe(catchError(handleFFAError));
    }
}

class FortniteResultService extends GiResultService {
    constructor() {
        super(...arguments);
        this.integration = "fortnite";
    }
}
FortniteResultService.ɵfac = function FortniteResultService_Factory(t) { return ɵFortniteResultService_BaseFactory(t || FortniteResultService); };
FortniteResultService.ɵprov = i0.ɵɵdefineInjectable({ token: FortniteResultService, factory: FortniteResultService.ɵfac, providedIn: "root" });
const ɵFortniteResultService_BaseFactory = /*@__PURE__*/ i0.ɵɵgetInheritedFactory(FortniteResultService);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FortniteResultService, [{
        type: Injectable,
        args: [{
                providedIn: "root",
            }]
    }], null, null); })();

class PubgResultService extends GiResultService {
    constructor() {
        super(...arguments);
        this.integration = "pubg";
    }
}
PubgResultService.ɵfac = function PubgResultService_Factory(t) { return ɵPubgResultService_BaseFactory(t || PubgResultService); };
PubgResultService.ɵprov = i0.ɵɵdefineInjectable({ token: PubgResultService, factory: PubgResultService.ɵfac, providedIn: "root" });
const ɵPubgResultService_BaseFactory = /*@__PURE__*/ i0.ɵɵgetInheritedFactory(PubgResultService);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PubgResultService, [{
        type: Injectable,
        args: [{
                providedIn: "root",
            }]
    }], null, null); })();

class PubgmResultService extends GiResultService {
    constructor() {
        super(...arguments);
        this.integration = "pubgmobile";
    }
}
PubgmResultService.ɵfac = function PubgmResultService_Factory(t) { return ɵPubgmResultService_BaseFactory(t || PubgmResultService); };
PubgmResultService.ɵprov = i0.ɵɵdefineInjectable({ token: PubgmResultService, factory: PubgmResultService.ɵfac, providedIn: "root" });
const ɵPubgmResultService_BaseFactory = /*@__PURE__*/ i0.ɵɵgetInheritedFactory(PubgmResultService);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PubgmResultService, [{
        type: Injectable,
        args: [{
                providedIn: "root",
            }]
    }], null, null); })();

class FFAResultServiceFactory {
    constructor(pubgService, pubgmService, fortniteService, defaultService) {
        this.pubgService = pubgService;
        this.pubgmService = pubgmService;
        this.fortniteService = fortniteService;
        this.defaultService = defaultService;
    }
    get(integration) {
        if (!integration) {
            return this.defaultService;
        }
        if (integration.split(",").indexOf("gameintegrationpubg") !== -1) {
            return this.pubgService;
        }
        if (integration.split(",").indexOf("gameintegrationpubgmobile") !== -1) {
            return this.pubgmService;
        }
        if (integration.split(",").indexOf("gameintegrationfortnite") !== -1) {
            return this.fortniteService;
        }
        return this.defaultService;
    }
    csvToJson(integration) {
        if (!integration) {
            return undefined;
        }
        if (integration.split(",").indexOf("gameintegrationpubg") !== -1) {
            return (csv) => csvjson.toObject(csv);
        }
        if (integration.split(",").indexOf("gameintegrationpubgmobile") !== -1) {
            return (csv) => csvjson.toObject(csv);
        }
        if (integration.split(",").indexOf("gameintegrationfortnite") !== -1) {
            return (csv) => csvjson.toObject(csv, { headers: "NickName,Rank,Kills" });
        }
        return undefined;
    }
}
FFAResultServiceFactory.ɵfac = function FFAResultServiceFactory_Factory(t) { return new (t || FFAResultServiceFactory)(i0.ɵɵinject(PubgResultService), i0.ɵɵinject(PubgmResultService), i0.ɵɵinject(FortniteResultService), i0.ɵɵinject(FFAResultService)); };
FFAResultServiceFactory.ɵprov = i0.ɵɵdefineInjectable({ token: FFAResultServiceFactory, factory: FFAResultServiceFactory.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FFAResultServiceFactory, [{
        type: Injectable,
        args: [{
                providedIn: "root",
            }]
    }], function () { return [{ type: PubgResultService }, { type: PubgmResultService }, { type: FortniteResultService }, { type: FFAResultService }]; }, null); })();

function PubgResultFromFileComponent_file_upload_dropzone_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "file-upload-dropzone", 6);
    i0.ɵɵlistener("dropped", function PubgResultFromFileComponent_file_upload_dropzone_6_Template_file_upload_dropzone_dropped_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.handleFile($event); });
    i0.ɵɵelementEnd();
} }
function PubgResultFromFileComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "loading-spinner");
    i0.ɵɵelementEnd();
} }
function PubgResultFromFileComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2, " OR ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelementStart(4, "span", 2);
    i0.ɵɵtext(5, " Enter result by lobby id / host nick name: ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelementStart(7, "label", 7);
    i0.ɵɵtext(8, "Lobby id: ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "input", 8);
    i0.ɵɵlistener("change", function PubgResultFromFileComponent_div_10_Template_input_change_9_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.handleNewLobbyId($event.target.value); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div");
    i0.ɵɵelementStart(11, "label", 9);
    i0.ɵɵtext(12, " Host Nick Name: ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "input", 10);
    i0.ɵɵlistener("change", function PubgResultFromFileComponent_div_10_Template_input_change_13_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.handleNewHostNickName($event.target.value); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "play-button", 11);
    i0.ɵɵlistener("clicked", function PubgResultFromFileComponent_div_10_Template_play_button_clicked_14_listener() { i0.ɵɵrestoreView(_r9); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.handleSaveByLobbyId(); });
    i0.ɵɵpipe(15, "async");
    i0.ɵɵpipe(16, "async");
    i0.ɵɵtext(17, " Save ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(9);
    i0.ɵɵpropertyInterpolate("value", ctx_r2.lobbyId);
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate("value", ctx_r2.hostNickName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(15, 4, ctx_r2.loading$))("loading", i0.ɵɵpipeBind1(16, 6, ctx_r2.loading$));
} }
function PubgResultFromFileComponent_div_11_inline_error_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const issue_r13 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", issue_r13, " ");
} }
function PubgResultFromFileComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2, " Saved result, but did not close match. Review the match manually. There were following issues: ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PubgResultFromFileComponent_div_11_inline_error_3_Template, 2, 1, "inline-error", 12);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(4, 1, ctx_r3.issues$));
} }
function PubgResultFromFileComponent_div_13_inline_error_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r15 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", error_r15, " ");
} }
function PubgResultFromFileComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2, " Failed saving result: ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PubgResultFromFileComponent_div_13_inline_error_3_Template, 2, 1, "inline-error", 12);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(4, 1, ctx_r4.errors$));
} }
function PubgResultFromFileComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, " Saved and closed successfully! ");
    i0.ɵɵelementEnd();
} }
class PubgResultFromFileComponent {
    constructor(service) {
        this.service = service;
        this.newResult = new EventEmitter();
        this.loading$ = new BehaviorSubject(false);
        this.issues$ = new BehaviorSubject([]);
        this.errors$ = new BehaviorSubject([]);
        this.success$ = new BehaviorSubject(false);
        this.lobbyId = "";
        this.hostNickName = "";
    }
    contestantTrackBy(index, contestant) {
        return contestant.rank;
    }
    handleFile(list) {
        const item = list.item(0);
        const fileReader = new FileReader();
        fileReader.onloadend = (event) => {
            this.issues$.next([]);
            this.errors$.next([]);
            this.success$.next(false);
            this.loading$.next(true);
            const service = this.service.get(this.integration);
            if (service instanceof GiResultService) {
                service
                    .saveCsv(this.matchId, this.transformCsv(event.target.result))
                    .pipe(first())
                    .subscribe((response) => {
                    if (response && response.issues) {
                        this.issues$.next(response.issues);
                        if (response.issues.length === 0) {
                            this.success$.next(true);
                        }
                    }
                    this.newResult.emit();
                }, (error) => this.errors$.next(error.getErrors()), () => this.loading$.next(false));
            }
        };
        fileReader.readAsText(item);
    }
    handleNewHostNickName(name) {
        this.hostNickName = name;
    }
    handleNewLobbyId(id) {
        this.lobbyId = id;
    }
    handleSaveByLobbyId() {
        this.issues$.next([]);
        this.errors$.next([]);
        this.success$.next(false);
        this.loading$.next(true);
        const service = this.service.get(this.integration);
        if (service instanceof GiResultService) {
            service
                .saveByLobbyId(this.matchId, this.lobbyId, this.hostNickName)
                .pipe(first())
                .subscribe((response) => {
                if (response && response.issues) {
                    this.issues$.next(response.issues);
                    if (response.issues.length === 0) {
                        this.success$.next(true);
                    }
                }
                this.newResult.emit();
            }, (error) => this.errors$.next(error.getErrors()), () => this.loading$.next(false));
        }
    }
    isPubg() {
        return (this.integration.split(",").indexOf("gameintegrationpubg") !== -1 ||
            this.integration.split(",").indexOf("gameintegrationpubgmobile") !== -1);
    }
}
PubgResultFromFileComponent.ɵfac = function PubgResultFromFileComponent_Factory(t) { return new (t || PubgResultFromFileComponent)(i0.ɵɵdirectiveInject(FFAResultServiceFactory)); };
PubgResultFromFileComponent.ɵcmp = i0.ɵɵdefineComponent({ type: PubgResultFromFileComponent, selectors: [["pubg-result-from-file"]], inputs: { matchId: "matchId", integration: "integration", transformCsv: "transformCsv" }, outputs: { newResult: "newResult" }, decls: 17, vars: 16, consts: [[1, "c-ffa-file-upload"], [1, "c-ffa-file-upload__options"], [1, "c-ffa-file-upload__label"], [1, "c-ffa-file-upload__box"], [3, "dropped", 4, "ngIf"], [4, "ngIf"], [3, "dropped"], ["for", "pubgLobbyId"], ["id", "pubgLobbyId", "type", "text", 3, "value", "change"], ["for", "pubgLobbyHostNickName"], ["id", "pubgLobbyHostNickName", "type", "text", 3, "value", "change"], [1, "c-button--primary", 3, "disabled", "loading", "clicked"], ["class", "c-ffa-file-upload__issue", 4, "ngFor", "ngForOf"], [1, "c-ffa-file-upload__issue"]], template: function PubgResultFromFileComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div");
        i0.ɵɵelementStart(3, "span", 2);
        i0.ɵɵtext(4, " Upload csv file: ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵtemplate(6, PubgResultFromFileComponent_file_upload_dropzone_6_Template, 1, 0, "file-upload-dropzone", 4);
        i0.ɵɵpipe(7, "async");
        i0.ɵɵtemplate(8, PubgResultFromFileComponent_div_8_Template, 2, 0, "div", 5);
        i0.ɵɵpipe(9, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, PubgResultFromFileComponent_div_10_Template, 18, 8, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, PubgResultFromFileComponent_div_11_Template, 5, 3, "div", 5);
        i0.ɵɵpipe(12, "async");
        i0.ɵɵtemplate(13, PubgResultFromFileComponent_div_13_Template, 5, 3, "div", 5);
        i0.ɵɵpipe(14, "async");
        i0.ɵɵtemplate(15, PubgResultFromFileComponent_div_15_Template, 2, 0, "div", 5);
        i0.ɵɵpipe(16, "async");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(7, 6, ctx.loading$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(9, 8, ctx.loading$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isPubg());
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(12, 10, ctx.issues$).length);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(14, 12, ctx.errors$).length);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(16, 14, ctx.success$));
    } }, directives: [i1.NgIf, i3.FileUploadDropzoneComponent, i3.LoadingSpinnerComponent, i3.ButtonComponent, i1.NgForOf, i3.InlineErrorComponent], pipes: [i1.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PubgResultFromFileComponent, [{
        type: Component,
        args: [{
                selector: "pubg-result-from-file",
                templateUrl: "./pubg-result-from-file.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: FFAResultServiceFactory }]; }, { matchId: [{
            type: Input
        }], integration: [{
            type: Input
        }], transformCsv: [{
            type: Input
        }], newResult: [{
            type: Output
        }] }); })();

function FFAResultComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function FFAResultComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function FFAResultComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function FFAResultComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "loading-spinner");
} }
function FFAResultComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelementStart(1, "inline-error");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "commons:data-fetch-error"), " ");
} }
function FFAResultComponent_ng_template_7_div_0_pubg_result_from_file_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "pubg-result-from-file", 13);
    i0.ɵɵlistener("newResult", function FFAResultComponent_ng_template_7_div_0_pubg_result_from_file_1_Template_pubg_result_from_file_newResult_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(3); return ctx_r16.handleNewResult(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("matchId", ctx_r10.matchId)("transformCsv", ctx_r10.transformCsv)("integration", ctx_r10.integration);
} }
function FFAResultComponent_ng_template_7_div_0_ffa_result_rank_3_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ffa-result-rank", 14);
    i0.ɵɵlistener("newContestant", function FFAResultComponent_ng_template_7_div_0_ffa_result_rank_3_Template_ffa_result_rank_newContestant_0_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(3); return ctx_r19.handleNewContestant($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ffaContestant_r18 = ctx.$implicit;
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ffaContestant", ffaContestant_r18)("availableTeams", ctx_r11.availableTeams)("teamSize", ctx_r11.teamSize)("isTeam", ctx_r11.isTeam);
} }
function FFAResultComponent_ng_template_7_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelementStart(1, "inline-error");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r21 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(error_r21);
} }
function FFAResultComponent_ng_template_7_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelementStart(1, "inline-error");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r22 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(error_r22);
} }
function FFAResultComponent_ng_template_7_div_0_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1, " Saved successfully! ");
    i0.ɵɵelementEnd();
} }
function FFAResultComponent_ng_template_7_div_0_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1, " Saved and closed successfully! ");
    i0.ɵɵelementEnd();
} }
function FFAResultComponent_ng_template_7_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FFAResultComponent_ng_template_7_div_0_pubg_result_from_file_1_Template, 1, 3, "pubg-result-from-file", 6);
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵtemplate(3, FFAResultComponent_ng_template_7_div_0_ffa_result_rank_3_Template, 1, 4, "ffa-result-rank", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, FFAResultComponent_ng_template_7_div_0_div_4_Template, 3, 1, "div", 9);
    i0.ɵɵtemplate(5, FFAResultComponent_ng_template_7_div_0_div_5_Template, 3, 1, "div", 9);
    i0.ɵɵelementStart(6, "play-button", 10);
    i0.ɵɵlistener("clicked", function FFAResultComponent_ng_template_7_div_0_Template_play_button_clicked_6_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(2); return ctx_r23.handleSave(); });
    i0.ɵɵtext(7, " Save ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "play-button", 11);
    i0.ɵɵlistener("clicked", function FFAResultComponent_ng_template_7_div_0_Template_play_button_clicked_8_listener() { i0.ɵɵrestoreView(_r24); const ctx_r25 = i0.ɵɵnextContext(2); return ctx_r25.handleSaveAndClose(); });
    i0.ɵɵtext(9, " Save & Close ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, FFAResultComponent_ng_template_7_div_0_span_10_Template, 2, 0, "span", 12);
    i0.ɵɵtemplate(11, FFAResultComponent_ng_template_7_div_0_span_11_Template, 2, 0, "span", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.transformCsv);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r9.ffaResult)("ngForTrackBy", ctx_r9.contestantTrackBy);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r9.saveErrors);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r9.validationErrors);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r9.saveLoading || ctx_r9.validationErrors.length)("loading", ctx_r9.saveLoading);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r9.saveLoading || ctx_r9.validationErrors.length)("loading", ctx_r9.saveLoading);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r9.saveSuccess);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.saveAndCloseSuccess);
} }
function FFAResultComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FFAResultComponent_ng_template_7_div_0_Template, 12, 11, "div", 5);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r8.ffaResult && ctx_r8.availableTeams && ctx_r8.teamSize);
} }
class FFAResultComponent {
    constructor() {
        this.newContestant = new EventEmitter();
        this.save = new EventEmitter();
        this.saveAndClose = new EventEmitter();
        this.newResult = new EventEmitter();
    }
    handleNewContestant(contestant) {
        this.newContestant.emit(contestant);
    }
    handleSave() {
        this.save.emit();
    }
    handleSaveAndClose() {
        this.saveAndClose.emit();
    }
    contestantTrackBy(index, contestant) {
        return contestant.rank;
    }
    handleNewResult() {
        this.newResult.emit();
    }
}
FFAResultComponent.ɵfac = function FFAResultComponent_Factory(t) { return new (t || FFAResultComponent)(); };
FFAResultComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FFAResultComponent, selectors: [["ffa-result"]], inputs: { isReady: "isReady", hasError: "hasError", isLoading: "isLoading", isTeam: "isTeam", integration: "integration", transformCsv: "transformCsv", availableTeams: "availableTeams", ffaResult: "ffaResult", teamSize: "teamSize", saveErrors: "saveErrors", saveLoading: "saveLoading", validationErrors: "validationErrors", saveSuccess: "saveSuccess", saveAndCloseSuccess: "saveAndCloseSuccess", matchId: "matchId", teams: "teams" }, outputs: { newContestant: "newContestant", save: "save", saveAndClose: "saveAndClose", newResult: "newResult" }, decls: 9, vars: 6, consts: [[4, "ngIf", "ngIfThen"], ["loading", ""], ["error", ""], ["ready", ""], [1, "ffa-result__error"], [4, "ngIf"], [3, "matchId", "transformCsv", "integration", "newResult", 4, "ngIf"], [1, "ffa-result__ranks"], [3, "ffaContestant", "availableTeams", "teamSize", "isTeam", "newContestant", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "ffa-result__error", 4, "ngFor", "ngForOf"], [1, "c-button--primary", 3, "disabled", "loading", "clicked"], [1, "c-button--destructive", 3, "disabled", "loading", "clicked"], ["class", "ffa-result__success", 4, "ngIf"], [3, "matchId", "transformCsv", "integration", "newResult"], [3, "ffaContestant", "availableTeams", "teamSize", "isTeam", "newContestant"], [1, "ffa-result__success"]], template: function FFAResultComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, FFAResultComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        i0.ɵɵtemplate(1, FFAResultComponent_ng_container_1_Template, 1, 0, "ng-container", 0);
        i0.ɵɵtemplate(2, FFAResultComponent_ng_container_2_Template, 1, 0, "ng-container", 0);
        i0.ɵɵtemplate(3, FFAResultComponent_ng_template_3_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(5, FFAResultComponent_ng_template_5_Template, 4, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(7, FFAResultComponent_ng_template_7_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(4);
        const _r5 = i0.ɵɵreference(6);
        const _r7 = i0.ɵɵreference(8);
        i0.ɵɵproperty("ngIf", ctx.isLoading)("ngIfThen", _r3);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasError)("ngIfThen", _r5);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isReady)("ngIfThen", _r7);
    } }, directives: [i1.NgIf, i3.LoadingSpinnerComponent, i3.InlineErrorComponent, i1.NgForOf, i3.ButtonComponent, PubgResultFromFileComponent, FFAResultRankComponent], pipes: [i5.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FFAResultComponent, [{
        type: Component,
        args: [{
                selector: "ffa-result",
                templateUrl: "./ffa-result.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { isReady: [{
            type: Input
        }], hasError: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], isTeam: [{
            type: Input
        }], integration: [{
            type: Input
        }], transformCsv: [{
            type: Input
        }], availableTeams: [{
            type: Input
        }], ffaResult: [{
            type: Input
        }], teamSize: [{
            type: Input
        }], saveErrors: [{
            type: Input
        }], saveLoading: [{
            type: Input
        }], validationErrors: [{
            type: Input
        }], saveSuccess: [{
            type: Input
        }], saveAndCloseSuccess: [{
            type: Input
        }], matchId: [{
            type: Input
        }], teams: [{
            type: Input
        }], newContestant: [{
            type: Output
        }], save: [{
            type: Output
        }], saveAndClose: [{
            type: Output
        }], newResult: [{
            type: Output
        }] }); })();

const FFAResultActionTypes = {
    LOAD_RESULT: type("[FFA Result] Load"),
    LOAD_ONCE_RESULT: spammyActionType("[FFA Result] Load Once"),
    LOAD_RESULT_COMPLETE: type("[FFA Result] Load Complete"),
};
class LoadResultAction {
    constructor(matchId, gameintegration, ignoreCache = false) {
        this.matchId = matchId;
        this.gameintegration = gameintegration;
        this.ignoreCache = ignoreCache;
        this.type = FFAResultActionTypes.LOAD_RESULT;
        this.payload = null;
    }
    get id() {
        return this.matchId;
    }
}
class LoadResultOnceAction extends LoadResultAction {
    constructor() {
        super(...arguments);
        this.type = FFAResultActionTypes.LOAD_ONCE_RESULT;
    }
}
class LoadResultCompleteAction {
    constructor(matchId, payload, error) {
        this.matchId = matchId;
        this.payload = payload;
        this.error = error;
        this.type = FFAResultActionTypes.LOAD_RESULT_COMPLETE;
    }
    get id() {
        return this.matchId;
    }
}

function getResultEntity(state) {
    return state.results;
}
function getFFAResultState(state) {
    return state.adminUi.ffaResult;
}
const getResult = createLoadSelector(compose(getResultEntity, getFFAResultState));

function ffaContestantToApi(contestant) {
    return {
        id: contestant.id,
        rank: contestant.rank,
        players: contestant.players.map(player => player),
    };
}
function playerContestantToTeam(player, gameaccount) {
    return {
        id: +player.id,
        name: player.nickname,
        members: [
            {
                id: +player.id,
                gameaccount: gameaccount,
            },
        ],
    };
}
function playerContestantsToTeams(contestants, gameaccounts) {
    return contestants.map(contestant => {
        const gameaccount = gameaccounts.find(ga => ga.id === +contestant.user.id);
        return playerContestantToTeam(contestant.user, gameaccount ? gameaccount.gameaccount : undefined);
    });
}
function teamContestantToTeam(team, members) {
    return {
        id: +team.id,
        name: team.name,
        members: members,
    };
}
function teamContestantToTeams(contestants, gameaccounts, rosters) {
    return contestants.map(contestant => {
        const rosterState = rosters.get(+contestant.team.id);
        let players = [];
        if (rosterState && rosterState.entry) {
            players = rosterState.entry.members
                .map(memberId => {
                const gameaccount = gameaccounts.find(ga => ga.id === memberId);
                return {
                    id: memberId,
                    gameaccount: gameaccount ? gameaccount.gameaccount : undefined,
                };
            })
                .filter(player => Boolean(player.gameaccount));
        }
        return teamContestantToTeam(contestant.team, players);
    });
}
function buildResult(teams, result, hasTiebreakers) {
    const base = teams.map((team, i) => {
        return {
            id: undefined,
            name: "Pick a contestant",
            rank: i + 1,
            players: [],
            members: [],
        };
    });
    const contestants = base.map(baseTeam => {
        const resultContestant = result === null || result === void 0 ? void 0 : result.find(contestant => contestant.rank === baseTeam.rank);
        if (!resultContestant) {
            return baseTeam;
        }
        const team = teams.find(item => item.id === resultContestant.id);
        if (!team) {
            return baseTeam;
        }
        const name = resultContestant.id === undefined ? baseTeam.name : team.name;
        if (!hasTiebreakers) {
            return {
                id: resultContestant.id,
                name: name,
                rank: resultContestant.rank,
                players: [],
                members: [],
            };
        }
        return {
            id: resultContestant.id,
            name: name,
            rank: resultContestant.rank,
            players: team
                ? resultContestant.players.map(player => {
                    if (player.id < 0) {
                        return Object.assign(Object.assign({}, player), { gameaccount: `Unknown${-player.id}`, name: `Unknown${-player.id}` });
                    }
                    return Object.assign(Object.assign({}, team.members.find(member => member.id === player.id)), player);
                })
                : [],
            members: team ? team.members : [],
        };
    });
    return contestants;
}
class FFAResultContainerComponent {
    constructor(store, service) {
        this.store = store;
        this.service = service;
        //
        this.saveErrors$ = new BehaviorSubject([]);
        this.saveLoading$ = new BehaviorSubject(false);
        this.saveSuccess$ = new BehaviorSubject(false);
        this.saveAndCloseSuccess$ = new BehaviorSubject(false);
        this.integrations = ["pubg", "fortnite", "pubgmobile"];
    }
    hasError() {
        return combineLatest(this.league$, this.match$, this.result$).pipe(map((data) => {
            return data.filter(entry => entry && entry.error).length !== 0;
        }));
    }
    isLoading() {
        return combineLatest(this.league$, this.match$, this.result$).pipe(map((data) => {
            return data.filter(entry => entry && entry.loading && !entry.entry).length !== 0;
        }));
    }
    isReady() {
        return combineLatest(this.isLoading$, this.hasError$).pipe(map(([loading, error]) => Boolean(!loading && !error)));
    }
    ngOnInit() {
        this.store.dispatch(new LoadMatchOnceAction(this.matchId));
        this.match$ = this.store.select(getMatch(this.matchId));
        this.result$ = this.store.select(getResult(this.matchId)).pipe(filter(exists));
        this.league$ = this.match$.pipe(filter(entryAvailable), tap(match => this.store.dispatch(new LoadLeagueOnceAction(+match.entry.leagueId))), switchMap(match => this.store.select(getLeague(+match.entry.leagueId))), filter(exists), tap(league => {
            if (league.entry) {
                this.store.dispatch(new LoadResultOnceAction(this.matchId, league.entry.gameIntegration));
            }
        }), shareReplay());
        this.integration$ = this.league$.pipe(filter(entryAvailable), map(league => league.entry.gameIntegration));
        this.transformCsv$ = this.league$.pipe(filter(entryAvailable), map(league => this.service.csvToJson(league.entry.gameIntegration)));
        this.isTeamLeague$ = this.league$.pipe(filter(entryAvailable), map(league => isTeam(league.entry)));
        this.isGi$ = this.league$.pipe(filter(entryAvailable), map(league => !!this.integrations.filter(integration => hasIntegration(league.entry, `gameintegration${integration}`)).length));
        this.hasTiebreakers$ = this.isGi$;
        this.teamSize$ = this.league$.pipe(filter(entryAvailable), map(league => league.entry.teamSize));
        const contestants$ = this.match$.pipe(filter(entryAvailable), map(match => match.entry.contestants));
        const rosters$ = contestants$.pipe(map(contestants => contestants.map(contestant => +contestant.team.id)), combineLatest$1(this.match$), switchMap(([contestantIds, match]) => {
            contestantIds.forEach(id => {
                this.store.dispatch(new LoadRosterOnceAction(+match.entry.leagueId, id));
            });
            return this.store.select(getRostersForTeams(+match.entry.leagueId, contestantIds));
        }), filter(Boolean), startWith(Map()), shareReplay());
        const gameAccounts$ = this.match$.pipe(filter(entryAvailable), map(match => match.entry.gameaccounts), map(gameaccounts => Object.keys(gameaccounts).map(key => ({
            id: +key,
            gameaccount: gameaccounts[key],
        }))));
        this.teamTeams$ = combineLatest(contestants$, rosters$, gameAccounts$).pipe(map(([contestants, rosters, gameAccounts]) => teamContestantToTeams(contestants, gameAccounts, rosters)));
        this.playerTeams$ = combineLatest(contestants$, gameAccounts$).pipe(map(([contestants, gameaccounts]) => playerContestantsToTeams(contestants, gameaccounts)));
        this.teams$ = this.teamSize$.pipe(map(size => size > 1), switchMap(isTeamLeague => {
            return isTeamLeague ? this.teamTeams$ : this.playerTeams$;
        }));
        this.ffaResult$ = combineLatest(this.teams$, this.result$.pipe(filter(entry => !entry.loading)), this.hasTiebreakers$).pipe(map(([teams, result, hasTiebreakers]) => buildResult(teams, result.entry, hasTiebreakers)));
        // Filter all teams already present in the result.
        this.availableTeams$ = combineLatest(this.teams$, this.ffaResult$).pipe(map(([teams, result]) => {
            return teams.filter(team => !this.isInResult(result, team));
        }));
        this.validationErrors$ = this.match$.pipe(filter(entryAvailable), map(match => {
            const errors = [];
            if (match.entry.status === "closed") {
                errors.push("Match is closed.");
            }
            return errors;
        }), startWith([]));
        this.isLoading$ = this.isLoading();
        this.hasError$ = this.hasError();
        this.isReady$ = this.isReady();
    }
    handleNewContestant(newContestant) {
        this.result$.pipe(first()).subscribe(result => {
            const currentContestant = result.entry.find(contestant => contestant.rank === newContestant.rank);
            const newResult = result.entry.map(contestant => {
                if (contestant.rank !== newContestant.rank) {
                    return contestant;
                }
                return ffaContestantToApi(newContestant);
            });
            if (!currentContestant) {
                newResult.push(ffaContestantToApi(newContestant));
            }
            this.store.dispatch(new LoadResultCompleteAction(this.matchId, newResult));
        });
    }
    handleSave() {
        this.saveErrors$.next([]);
        this.saveLoading$.next(true);
        this.saveSuccess$.next(false);
        this.saveAndCloseSuccess$.next(false);
        this.result$
            .pipe(combineLatest$1(this.league$), switchMap(([result, league]) => {
            return this.service.get(league.entry.gameIntegration).save(this.matchId, result.entry);
        }), first())
            .subscribe(() => this.saveSuccess$.next(true), (error) => {
            this.saveErrors$.next(error.getErrors());
            this.saveLoading$.next(false);
        }, () => this.saveLoading$.next(false));
    }
    handleSaveAndClose() {
        this.saveErrors$.next([]);
        this.saveLoading$.next(true);
        this.saveSuccess$.next(false);
        this.saveAndCloseSuccess$.next(false);
        this.result$
            .pipe(combineLatest$1(this.league$), switchMap(([result, league]) => {
            return this.service.get(league.entry.gameIntegration).saveAndClose(this.matchId, result.entry);
        }), first())
            .subscribe(() => {
            this.saveAndCloseSuccess$.next(true);
            this.store.dispatch(new LoadMatchAction(this.matchId));
        }, (error) => {
            this.saveErrors$.next(error.getErrors());
            this.saveLoading$.next(false);
        }, () => this.saveLoading$.next(false));
    }
    handleNewResult() {
        this.store.dispatch(new LoadMatchAction(this.matchId));
        this.league$.pipe(filter(entryAvailable), first()).subscribe(league => {
            this.store.dispatch(new LoadResultAction(this.matchId, league.entry.gameIntegration));
        });
    }
    isInResult(result, team) {
        return Boolean(result.find(contestant => contestant.id === team.id));
    }
}
FFAResultContainerComponent.ɵfac = function FFAResultContainerComponent_Factory(t) { return new (t || FFAResultContainerComponent)(i0.ɵɵdirectiveInject(i1$2.Store), i0.ɵɵdirectiveInject(FFAResultServiceFactory)); };
FFAResultContainerComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FFAResultContainerComponent, selectors: [["ffa-result-container"]], inputs: { matchId: "matchId" }, decls: 16, vars: 46, consts: [[3, "hasError", "isLoading", "isReady", "matchId", "ffaResult", "teams", "availableTeams", "teamSize", "isTeam", "transformCsv", "integration", "validationErrors", "saveErrors", "saveLoading", "saveSuccess", "saveAndCloseSuccess", "newContestant", "save", "saveAndClose", "newResult"]], template: function FFAResultContainerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ffa-result", 0);
        i0.ɵɵlistener("newContestant", function FFAResultContainerComponent_Template_ffa_result_newContestant_0_listener($event) { return ctx.handleNewContestant($event); })("save", function FFAResultContainerComponent_Template_ffa_result_save_0_listener() { return ctx.handleSave(); })("saveAndClose", function FFAResultContainerComponent_Template_ffa_result_saveAndClose_0_listener() { return ctx.handleSaveAndClose(); })("newResult", function FFAResultContainerComponent_Template_ffa_result_newResult_0_listener() { return ctx.handleNewResult(); });
        i0.ɵɵpipe(1, "async");
        i0.ɵɵpipe(2, "async");
        i0.ɵɵpipe(3, "async");
        i0.ɵɵpipe(4, "async");
        i0.ɵɵpipe(5, "async");
        i0.ɵɵpipe(6, "async");
        i0.ɵɵpipe(7, "async");
        i0.ɵɵpipe(8, "async");
        i0.ɵɵpipe(9, "async");
        i0.ɵɵpipe(10, "async");
        i0.ɵɵpipe(11, "async");
        i0.ɵɵpipe(12, "async");
        i0.ɵɵpipe(13, "async");
        i0.ɵɵpipe(14, "async");
        i0.ɵɵpipe(15, "async");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("hasError", i0.ɵɵpipeBind1(1, 16, ctx.hasError$))("isLoading", i0.ɵɵpipeBind1(2, 18, ctx.isLoading$))("isReady", i0.ɵɵpipeBind1(3, 20, ctx.isReady$))("matchId", ctx.matchId)("ffaResult", i0.ɵɵpipeBind1(4, 22, ctx.ffaResult$))("teams", i0.ɵɵpipeBind1(5, 24, ctx.teams$))("availableTeams", i0.ɵɵpipeBind1(6, 26, ctx.availableTeams$))("teamSize", i0.ɵɵpipeBind1(7, 28, ctx.teamSize$))("isTeam", i0.ɵɵpipeBind1(8, 30, ctx.isTeamLeague$))("transformCsv", i0.ɵɵpipeBind1(9, 32, ctx.transformCsv$))("integration", i0.ɵɵpipeBind1(10, 34, ctx.integration$))("validationErrors", i0.ɵɵpipeBind1(11, 36, ctx.validationErrors$))("saveErrors", i0.ɵɵpipeBind1(12, 38, ctx.saveErrors$))("saveLoading", i0.ɵɵpipeBind1(13, 40, ctx.saveLoading$))("saveSuccess", i0.ɵɵpipeBind1(14, 42, ctx.saveSuccess$))("saveAndCloseSuccess", i0.ɵɵpipeBind1(15, 44, ctx.saveAndCloseSuccess$));
    } }, directives: [FFAResultComponent], pipes: [i1.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FFAResultContainerComponent, [{
        type: Component,
        args: [{
                selector: "ffa-result-container",
                templateUrl: "./ffa-result-container.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$2.Store }, { type: FFAResultServiceFactory }]; }, { matchId: [{
            type: Input
        }] }); })();

class FFAResultComponentsModule {
}
FFAResultComponentsModule.ɵfac = function FFAResultComponentsModule_Factory(t) { return new (t || FFAResultComponentsModule)(); };
FFAResultComponentsModule.ɵmod = i0.ɵɵdefineNgModule({ type: FFAResultComponentsModule });
FFAResultComponentsModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            CommonModule,
            HttpClientModule,
            FormsModule,
            CommonsErrorModule,
            CommonsComponentModule,
            CommonsLoadingModule,
            SvgIconsModule,
            TranslationModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FFAResultComponentsModule, { declarations: [FFAResultComponent,
        FFAResultContainerComponent,
        FFAResultRankComponent,
        FFAResultMembersComponent,
        FFAResultPlayerComponent,
        FocusOnInitDirective,
        PubgResultFromFileComponent,
        FilterDropdownComponent], imports: [CommonModule,
        CommonModule,
        HttpClientModule,
        FormsModule,
        CommonsErrorModule,
        CommonsComponentModule,
        CommonsLoadingModule,
        SvgIconsModule,
        TranslationModule], exports: [FFAResultContainerComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FFAResultComponentsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    CommonModule,
                    HttpClientModule,
                    FormsModule,
                    CommonsErrorModule,
                    CommonsComponentModule,
                    CommonsLoadingModule,
                    SvgIconsModule,
                    TranslationModule,
                ],
                declarations: [
                    FFAResultComponent,
                    FFAResultContainerComponent,
                    FFAResultRankComponent,
                    FFAResultMembersComponent,
                    FFAResultPlayerComponent,
                    FocusOnInitDirective,
                    PubgResultFromFileComponent,
                    FilterDropdownComponent,
                ],
                exports: [FFAResultContainerComponent],
            }]
    }], null, null); })();

class FFAResultEffects {
    constructor(actions$, service, state$) {
        this.actions$ = actions$;
        this.service = service;
        this.state$ = state$;
        this.loadResult$ = this.actions$.pipe(ofType(FFAResultActionTypes.LOAD_RESULT), mergeMap((action) => {
            const nextSearch$ = this.actions$.pipe(ofType(FFAResultActionTypes.LOAD_RESULT), filter((action2) => action.matchId === action2.matchId), skip(1));
            const service = this.service.get(action.gameintegration);
            return service.get(action.matchId).pipe(catchError((err, caught) => {
                if (err.getStatus() === 404) {
                    return of([]);
                }
                return throwError(err);
            }), takeUntil(nextSearch$), map(match => new LoadResultCompleteAction(action.matchId, match)), catchError(error => of(new LoadResultCompleteAction(action.matchId, null, createErrorObject(error)))));
        }));
        this.loadResultOnce$ = this.actions$.pipe(ofType(FFAResultActionTypes.LOAD_ONCE_RESULT), mergeMap((action) => {
            return this.state$.select(getResult(action.matchId)).pipe(first(), filter(data => !exists(data)), map(data => action));
        }), mergeMap(action => [new LoadResultAction(action.matchId, action.gameintegration)]));
    }
}
FFAResultEffects.ɵfac = function FFAResultEffects_Factory(t) { return new (t || FFAResultEffects)(i0.ɵɵinject(i1$3.Actions), i0.ɵɵinject(FFAResultServiceFactory), i0.ɵɵinject(i1$2.Store)); };
FFAResultEffects.ɵprov = i0.ɵɵdefineInjectable({ token: FFAResultEffects, factory: FFAResultEffects.ɵfac });
__decorate([
    Effect(),
    __metadata("design:type", Observable)
], FFAResultEffects.prototype, "loadResult$", void 0);
__decorate([
    Effect(),
    __metadata("design:type", Observable)
], FFAResultEffects.prototype, "loadResultOnce$", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FFAResultEffects, [{
        type: Injectable
    }], function () { return [{ type: i1$3.Actions }, { type: FFAResultServiceFactory }, { type: i1$2.Store }]; }, { loadResult$: [], loadResultOnce$: [] }); })();

class FFAResultModule {
}
FFAResultModule.ɵfac = function FFAResultModule_Factory(t) { return new (t || FFAResultModule)(); };
FFAResultModule.ɵmod = i0.ɵɵdefineNgModule({ type: FFAResultModule });
FFAResultModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            HttpClientModule,
            FormsModule,
            CommonsErrorModule,
            CommonsComponentModule,
            CommonsLoadingModule,
            SvgIconsModule,
            TranslationModule,
            StateModule,
            FFAResultComponentsModule,
            EffectsModule.forFeature([FFAResultEffects]),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FFAResultModule, { imports: [CommonModule,
        HttpClientModule,
        FormsModule,
        CommonsErrorModule,
        CommonsComponentModule,
        CommonsLoadingModule,
        SvgIconsModule,
        TranslationModule,
        StateModule,
        FFAResultComponentsModule, i1$3.EffectsFeatureModule], exports: [FFAResultContainerComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FFAResultModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    HttpClientModule,
                    FormsModule,
                    CommonsErrorModule,
                    CommonsComponentModule,
                    CommonsLoadingModule,
                    SvgIconsModule,
                    TranslationModule,
                    StateModule,
                    FFAResultComponentsModule,
                    EffectsModule.forFeature([FFAResultEffects]),
                ],
                declarations: [],
                exports: [FFAResultContainerComponent],
            }]
    }], null, null); })();

const reducers = combineReducers({
    results: createMultipleLoadReducer(FFAResultActionTypes.LOAD_RESULT, FFAResultActionTypes.LOAD_RESULT_COMPLETE),
});
function ffaResultReducer(state, action) {
    return reducers(state, action);
}

const adminUiReducers = {
    ffaResult: ffaResultReducer,
};

class AdminUiModule {
}
AdminUiModule.ɵfac = function AdminUiModule_Factory(t) { return new (t || AdminUiModule)(); };
AdminUiModule.ɵmod = i0.ɵɵdefineNgModule({ type: AdminUiModule });
AdminUiModule.ɵinj = i0.ɵɵdefineInjector({ providers: [{ provide: FFA_RESULT_CONFIG, useValue: FFAResultProdConfig }], imports: [[
            CommonModule,
            CommonsErrorModule,
            CommonsLoadingModule,
            TranslationModule,
            FFAResultModule,
            StoreModule.forFeature("adminUi", adminUiReducers),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(AdminUiModule, { imports: [CommonModule,
        CommonsErrorModule,
        CommonsLoadingModule,
        TranslationModule,
        FFAResultModule, i1$2.StoreFeatureModule], exports: [FFAResultContainerComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AdminUiModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    CommonsErrorModule,
                    CommonsLoadingModule,
                    TranslationModule,
                    FFAResultModule,
                    StoreModule.forFeature("adminUi", adminUiReducers),
                ],
                exports: [FFAResultContainerComponent],
                providers: [{ provide: FFA_RESULT_CONFIG, useValue: FFAResultProdConfig }],
            }]
    }], null, null); })();

/*
 * Public API Surface of admin-ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AdminUiModule, FFAErrorResponse, FFAResultComponent, FFAResultContainerComponent, FFAResultMembersComponent, FFAResultModule, FFAResultPlayerComponent, FFAResultProdConfig, FFAResultRankComponent, FFAResultService, FFAResultServiceFactory, FFA_RESULT_CONFIG, FilterDropdownComponent, FocusOnInitDirective, FortniteResultService, GiResultService, PubgResultFromFileComponent, PubgResultService, buildResult, ffaContestantToApi, handleFFAError, playerContestantsToTeams, teamContestantToTeam, teamContestantToTeams };
//# sourceMappingURL=play-admin-ui.js.map
